import Button from 'atoms/button';
import ServiceBlock from 'organisms/ServiceBlock';

import NoServicesCTA from './NoServicesCTA';

export default function Services({ isMyProvider, onAddService, services }) {
  return (
    <div className="services">
      {services?.length > 0 ? (
        <>
          <div className="services-header mb-32">
            {isMyProvider && onAddService && (
              <Button
                onClick={onAddService}
                text="Add service"
                variant="reverse"
                size="medium"
                icon="add"
                iconPosition="start"
              />
            )}
            <div className="services-header-text">
              <h1>Services</h1>
              <p className="c-primary-purple">
                Your available services are listed below
              </p>
            </div>
          </div>
          {services.map((service) => (
            <ServiceBlock
              isMyProvider={isMyProvider}
              actionsOnHover
              className="services-service"
              key={service.uuid}
              service={service}
            />
          ))}
        </>
      ) : (
        <NoServicesCTA onClick={onAddService} />
      )}
    </div>
  );
}
